import { createI18n } from 'vue-i18n'

const loadLocaleMessages = async (locale: string) => {
  try {
    const messages = await import(`../../public/${locale}.json`)
    return messages.default
  } catch (error) {
    console.error(`Failed to load locale messages for ${locale}:`, error)
    return null
  }
}

const formatsCache: Record<string, any> = {}
const loadFormats = async (locale: string) => {
  if (formatsCache[locale]) {
    return formatsCache[locale]
  }
  try {
    let formats
    switch (locale) {
      case 'de':
        formats = await import('./formats/de')
        break
      case 'es':
        formats = await import('./formats/es')
        break
      case 'jp':
        formats = await import('./formats/jp')
        break
      default:
        formats = await import('./formats/en')
    }
    formatsCache[locale] = formats.default
    return formats.default
  } catch (error) {
    console.error(`Failed to load formats for ${locale}:`, error)
    return null
  }
}
const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  missingWarn: false,
  warnHtmlMessage: false,
  messages: {},
  numberFormats: {},
  datetimeFormats: {},
})
const loadAndSetLocale = async (locale: string): Promise<boolean> => {
  const messages = await loadLocaleMessages(locale)
  if (!messages) {
    return false
  }

  const formats = await loadFormats(locale)
  if (!formats) {
    return false
  }

  i18n.global.setLocaleMessage(locale, messages)
  i18n.global.setNumberFormat(locale, formats.numberFormats)
  i18n.global.setDateTimeFormat(locale, formats.datetimeFormats)
  i18n.global.locale.value = locale
  if (typeof messages.metadata?.title === 'string') {
    document.title = messages.metadata.title
  }
  return true
}
export { i18n, loadAndSetLocale }
